import {
  FETCH_AD_REQUEST,
  FETCH_AD_START,
  FETCH_AD_SUCCESS,
  FETCH_AD_FAILED,
  CHANGE_AD_PAGE,
  SAVE_APPLY_START,
  SAVE_APPLY,
  SAVE_APPLY_SUCCESS,
  SAVE_APPLY_FAILED,
  FETCH_RELATED_ADS_START,
  FETCH_RELATED_ADS_REQUEST,
  FETCH_RELATED_ADS_SUCCESS,
  FETCH_RELATED_ADS_FAILED,
  NAVIGATE_AD_PAGE,
  NAVIGATE_TO_HOME,
  NAVIGATE_TO_HOME_OR_LAST_SEARCH,
  ENABLE_RELATED_ADS_FETCH,
} from './constants';
import { guardNullOrUndefined } from '../utils/guards';

export const fetchAdStart = () => ({ type: FETCH_AD_START });

export const fetchAdRequest = id => {
  guardNullOrUndefined(id);
  return { type: FETCH_AD_REQUEST, id };
};

export const fetchAdSuccess = ad => {
  guardNullOrUndefined(ad);
  return { type: FETCH_AD_SUCCESS, ad };
};

export const fetchAdFailed = error => {
  guardNullOrUndefined(error);
  return { type: FETCH_AD_FAILED, error };
};

export const changeAdPage = ad => {
  guardNullOrUndefined(ad);
  return { type: CHANGE_AD_PAGE, ad };
};

export const saveApplyStart = () => ({ type: SAVE_APPLY_START });

export const saveApply = data => {
  guardNullOrUndefined(data);
  return { type: SAVE_APPLY, data };
};

export const saveApplySuccess = data => {
  guardNullOrUndefined(data);
  return { type: SAVE_APPLY_SUCCESS, data };
};

export const saveApplyFailed = error => {
  guardNullOrUndefined(error);
  return { type: SAVE_APPLY_FAILED, error };
};

export const fetchRelatedAdsStart = () => ({ type: FETCH_RELATED_ADS_START });

export const fetchRelatedAdsRequest = data => {
  guardNullOrUndefined(data);
  return { type: FETCH_RELATED_ADS_REQUEST, data };
};

export const fetchRelatedAdsSuccess = res => {
  guardNullOrUndefined(res);
  return { type: FETCH_RELATED_ADS_SUCCESS, res };
};

export const fetchRelatedAdsFailed = error => {
  guardNullOrUndefined(error);
  return { type: FETCH_RELATED_ADS_FAILED, error };
};

export const navigateAdPage = ad => {
  guardNullOrUndefined(ad);
  return { type: NAVIGATE_AD_PAGE, ad };
};

export const navigateToHome = () => ({
  type: NAVIGATE_TO_HOME,
});

export const navigateToHomeOrLastSearch = () => ({
  type: NAVIGATE_TO_HOME_OR_LAST_SEARCH,
});

export const enableFetchRelatedAds = isEnabled => ({ type: ENABLE_RELATED_ADS_FETCH, isEnabled });



// WEBPACK FOOTER //
// ./app/AdPage/actions.js